import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function TabValoreAggiunto(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_VALORE_AGGIUNTO_DICHIARATI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.valDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.valDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.valDic
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_VALORE_AGGIUNTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.valSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.valSti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.valSti
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_VALORE_AGGIUNTO_ADDETTO_DICHIARATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.vaAddDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.vaAddDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.vaAddDic
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_VALORE_AGGIUNTO_ADDETTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.vaAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.vaAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.vaAddSti
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default TabValoreAggiunto
